import {
  SET_LOADING_STATE,
  UPDATE_BATCH_FILE,
  UPDATE_CATEGORIES,
  UPDATE_DEFAULT_CONTACT_LIST,
  UPDATE_FINANCIAL_CONTACT,
  UPDATE_NDIS_CATALOGUE,
  UPDATE_NOTIFICATION_STATS,
  UPDATE_NOTIFICATIONS,
  UPDATE_ORG_ID,
  UPDATE_PRODUCT,
  UPDATE_REGO_LIST,
  UPDATE_REMITTANCE,
  UPDATE_SAH_PROVIDER_LIST,
  UPDATE_SUCCESSFUL_CLAIMS,
  UPDATE_USER_INFO,
} from '../actions/action-types';

interface IInitialAppState {
  user: Object;
  regos: Array<Object>;
  financialContact: Array<Object>;
  ndis_catalogue: Array<Object>;
  batch_file_list: Array<Object>;
  orgDefaultContactList: Array<Object>;
  successful_claims: any;
  remittance: any;
  notifications: any;
  categories: any;
  orgId: string;
  sahProviders: Array<Object>;
  loadingStates: {
    userInfo: boolean;
    notificationStats: boolean;
    rego: boolean;
    categoryX: boolean;
    categoryY: boolean;
    financialContact: boolean;
    product: boolean;
    ndisCatalogue: boolean;
  };
}

const initialState: IInitialAppState = {
  user: {},
  regos: [],
  sahProviders: [],
  ndis_catalogue: [],
  financialContact: [],
  successful_claims: {},
  batch_file_list: [],
  orgDefaultContactList: [],
  remittance: {},
  notifications: {},
  categories: {},
  orgId: '',
  loadingStates: {
    userInfo: true,
    notificationStats: false,
    rego: false,
    categoryX: false,
    categoryY: false,
    financialContact: false,
    product: false,
    ndisCatalogue: false,
  },
};

// eslint-disable-next-line default-param-last
const appReducer = (state = initialState, action: { type: any; payload: any }) => {
  switch (action.type) {
    case UPDATE_USER_INFO:
      return {
        ...state,
        user: {
          ...action.payload,
        },
        loadingStates: {
          ...state.loadingStates,
          userInfo: false,
        },
      };

    case UPDATE_ORG_ID:
      return {
        ...state,
        orgId: action.payload,
      };

    case UPDATE_REGO_LIST:
      return {
        ...state,
        regos: action.payload,
      };

    case UPDATE_NDIS_CATALOGUE:
      return {
        ...state,
        ndis_catalogue: action.payload,
      };

    case UPDATE_SUCCESSFUL_CLAIMS:
      return {
        ...state,
        successful_claims: {
          data: {
            ...state.successful_claims.data,
            ...action.payload.data,
          },
          pagination: action.payload.pagination,
        },
      };

    case UPDATE_REMITTANCE:
      return {
        ...state,
        remittance: {
          data: {
            ...state.remittance.data,
            ...action.payload.data,
          },
          pagination: action.payload.pagination,
        },
      };

    case UPDATE_BATCH_FILE:
      return {
        ...state,
        batch_file_list: action.payload,
      };

    case UPDATE_FINANCIAL_CONTACT:
      return {
        ...state,
        financialContact: action.payload,
      };

    case UPDATE_PRODUCT:
      return {
        ...state,
        product: action.payload,
      };
    case UPDATE_NOTIFICATION_STATS:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          ...action.payload,
        },
      };
    case UPDATE_NOTIFICATIONS:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          ...action.payload,
        },
      };

    case UPDATE_CATEGORIES:
      return {
        ...state,
        categories: {
          ...state.categories,
          [action.payload.type]: action.payload.data,
        },
      };

    case UPDATE_DEFAULT_CONTACT_LIST:
      return {
        ...state,
        orgDefaultContactList: action.payload,
      };

    case SET_LOADING_STATE:
      return {
        ...state,
        loadingStates: {
          ...state.loadingStates,
          [action.payload.key]: action.payload.value,
        },
      };

    case UPDATE_SAH_PROVIDER_LIST:
      return {
        ...state,
        sahProviders: action.payload,
      };

    default:
      return state;
  }
};
export default appReducer;
